'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { MobileTradeCta, MobileTradeSheetShell } from '@/components/market/mobile-trade-shell';
import { DirectTokenPurchaseAction } from '@/components/onramp/direct-purchase/direct-token-purchase-action';
import type { TradeFormProps } from '@/components/trade/trade-form';
import { TradeFormBare } from '@/components/trade/trade-form';

/** Indexed pool snapshot props forwarded to the inner AMM trade form. */
type WinnerTradeReserveProps = Pick<TradeFormProps, 'tradeData' | 'marketDataStale' | 'marketDataPending' | 'marketDataRefreshing' | 'onRetryMarketData'>;
export interface WinnerMobileTradeProps {
  marketAddress: string;
  /** Winning-token display name — forwarded to the realised-PnL sell share text. */
  marketTitle?: string;
  /** Full outcome list (position === index) — the form indexes into it. */
  outcomes: TradeFormProps['outcomes'];
  /** Locked winning-outcome index (the graduated AMM token). */
  selectedOutcomeIndex: number;
  reserveProps: WinnerTradeReserveProps;
}

/**
 * Mobile/tablet trade surface for the `/winners` token page — the responsive
 * mirror of the market-detail floating trade button. A fixed bottom CTA opens a
 * SilkSheet carrying the bare AMM Buy/Sell form, so the winning-token detail page
 * matches the market page instead of dumping the full form inline. Desktop keeps
 * the form in the sticky right column (`lg:hidden` here). The outcome is locked
 * to the graduated winner and trading runs on the AMM path (`allowGraduatedAmm`).
 */
export function WinnerMobileTrade(t0) {
  const $ = _c(18);
  const {
    marketAddress,
    marketTitle,
    outcomes,
    selectedOutcomeIndex,
    reserveProps
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== marketAddress || $[2] !== selectedOutcomeIndex) {
    t2 = <MobileTradeCta onOpen={t1} testIdPrefix="winner-mobile-trade" purchaseAction={<DirectTokenPurchaseAction placement="responsive" marketAddress={marketAddress} outcomeIndex={selectedOutcomeIndex} origin="winner" />} />;
    $[1] = marketAddress;
    $[2] = selectedOutcomeIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== marketTitle) {
    t3 = marketTitle !== undefined ? {
      marketTitle
    } : {};
    $[4] = marketTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== marketAddress || $[7] !== outcomes || $[8] !== reserveProps || $[9] !== selectedOutcomeIndex || $[10] !== t3) {
    t4 = <TradeFormBare marketAddress={marketAddress} outcomes={outcomes} selectedOutcomeIndex={selectedOutcomeIndex} marketStatus="graduated" allowGraduatedAmm={true} lockOutcome={true} hasHoldings={false} {...t3} {...reserveProps} />;
    $[6] = marketAddress;
    $[7] = outcomes;
    $[8] = reserveProps;
    $[9] = selectedOutcomeIndex;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== open || $[13] !== t4) {
    t5 = <MobileTradeSheetShell open={open} onOpenChange={setOpen}>{t4}</MobileTradeSheetShell>;
    $[12] = open;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}